import React, { useMemo } from 'react'
import { makeStyles } from '@material-ui/core'
import { Button, Stepper } from 'foundations-library/components'
import { StepperType } from 'foundations-library/types'

const jss = (theme) => {
    // const { colors } = theme['foundations-library']
    return {
        stepContainer: {
            maxWidth: '1000px',
            margin: '40px auto 0 auto'
        },
        stepContent: {
            alignItems: 'center',
            gap: '40px',
            padding: '20px',
            borderRadius: '10px',
            border: '1px solid var(--Neutral-100, #D9D8D8)'
            // boxShadow: '0 4px 4px 0 rgba(0, 0, 0, 0.25), 0 4px 4px 0 rgba(0, 0, 0, 0.25)',
        },
        buttons: {
            marginTop: 40,
            display: 'flex',
            justifyContent: 'end',
            gap: 20
        },
        nextBtn: {
            width: 155
        }
    }
}

const useStyles = makeStyles(jss)

type PropsType = Pick<StepperType, 'items' | 'disabled' | 'onChange' | 'value' | 'width' | 'data-testid'>;

/**
 *
 */
const Wizard = ({
    value,
    items,
    onChange,
    ...props
}: PropsType): JSX.Element => {
    const styles = useStyles()
    const currentStep = useMemo(() => items.find((x) => x.value === value) || {}, [items, value])
    const isLastItem = currentStep.value === items[items.length - 1].value
    const isFirstItem = currentStep.value === items[0].value
    const findCurrentIndex = () => items.findIndex((x) => x.value === currentStep.value)
    const onClinckBack = () => {
        const prevStepIndex = findCurrentIndex() - 1
        if (prevStepIndex <= 0 && onChange) {
            onChange(items[prevStepIndex].value)
        }
    }
    const onClinckNext = () => {
        const nextStepIndex = findCurrentIndex() + 1
        if (items.length >= nextStepIndex && onChange) {
            onChange(items[nextStepIndex].value)
        }
    }
    return <div>
        <Stepper
            value={value}
            items={items}
            onChange={onChange}
            {...props}
        />
        <div className={styles.stepContainer}>
            <div className={styles.stepContent}>test</div>
            <div className={styles.buttons}>
                {!isFirstItem ? <Button onClick={onClinckBack} color='neutral' variant='outlined'>Back</Button> : null}
                {!isLastItem ? <Button onClick={onClinckNext} color='primary' className={styles.nextBtn} disabled={!currentStep.completed}>Next</Button> : null}
            </div>
        </div>
    </div>
}

export default Wizard
